import { useEffect, useRef } from 'react';

/**
 * Keep the viewport pinned to the top (newest messages) unless the user has
 * scrolled down into history.
 */
export function useOcppCommandConsoleScroll(entryCount: number) {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) {
      return;
    }
    if (el.scrollTop <= 32) {
      el.scrollTop = 0;
    }
  }, [entryCount]);

  return scrollRef;
}
